import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import {
  type OpalApiResponseDocument,
  type OpalApiRequestParams,
} from '../../schema'

type ReadBoardUserSettingOperation = 'ReadBoardUserSettingV3'

export type ReadBoardUserSettingResponse = OpalApiResponseDocument<
  ReadBoardUserSettingOperation,
  200
>

export async function readBoardUserSetting(
  params: OpalApiRequestParams<ReadBoardUserSettingOperation>
): Promise<ReadBoardUserSettingResponse> {
  const url = new URL(
    `/boards/v3/${params.path.board_id}/user_setting`,
    window.location.origin
  )

  url.search = queryString(params.query)

  const res = await HttpClient().get(url.toString())
  return res.data
}
